"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.subsectionVariantBlueprint = exports.quoterSubsectionBlueprintVariant = void 0;
const t = __importStar(require("typegate"));
const subsectionVariant_1 = require("../carrierQuestionnaire/subsectionVariant");
// TODO: Add other `SubsectionVariants`s here. Some variants may have additional parameters (not just `type`).
const summarySubsectionBlueprintVariant = t.object(t.property('type', t.literal(subsectionVariant_1.SubsectionVariants.summary)));
const submissionSubsectionBlueprintVariant = t.object(t.property('type', t.literal(subsectionVariant_1.SubsectionVariants.submission)), t.property('displayInline', t.boolean), t.property('hideHeader', t.boolean));
const addonSubsectionBlueprintVariant = t.object(t.property('type', t.literal(subsectionVariant_1.SubsectionVariants.addon)));
exports.quoterSubsectionBlueprintVariant = t.object(t.property('type', t.literal(subsectionVariant_1.SubsectionVariants.quoter)), t.property('productNodeIds', t.object(t.property('product', t.string), t.property('coverageAmount', t.string))), t.optionalProperty('simpleQuoter', t.object(t.property('useNeedsAnalysisNodeId', t.string))));
const paymentSubsectionBlueprintVariant = t.object(t.property('type', t.literal(subsectionVariant_1.SubsectionVariants.payment)));
const productSummarySubsectionBlueprintVariant = t.object(t.property('type', t.literal(subsectionVariant_1.SubsectionVariants.productSummary)));
const productSelectionSubsectionBlueprintVariant = t.object(t.property('type', t.literal(subsectionVariant_1.SubsectionVariants.productSelection)));
const formSubsectionBlueprintVariant = t.object(t.property('type', t.literal(subsectionVariant_1.SubsectionVariants.form)));
const priceUpdateWarningSubsectionBlueprintVariant = t.object(t.property('type', t.literal(subsectionVariant_1.SubsectionVariants.priceUpdateWarning)));
exports.subsectionVariantBlueprint = t.union(summarySubsectionBlueprintVariant, exports.quoterSubsectionBlueprintVariant, paymentSubsectionBlueprintVariant, submissionSubsectionBlueprintVariant, addonSubsectionBlueprintVariant, productSelectionSubsectionBlueprintVariant, productSummarySubsectionBlueprintVariant, formSubsectionBlueprintVariant, priceUpdateWarningSubsectionBlueprintVariant);
